import { __assign, __spreadArray } from "tslib";
import React from 'react';
import classnames from 'classnames';
import MediaService, { fallbackToLargestFile, } from '../utils/DeviationMediaService';
import { BackgroundType, BackgroundImageDisplayMode, } from './types';
import { TEMPLATES } from './templates';
import { gradientToClassName } from './utils';
import { styleFromWidthHeight } from '../DeviationViews/_helpers';
import { useDeviationMatureFilter } from '../utils/hooks/useDeviationMatureFilter';
import s from './Background.scss';
var Background = function (_a) {
    var className = _a.className, contentClassName = _a.contentClassName, backgroundClassName = _a.backgroundClassName, children = _a.children, onClick = _a.onClick, _b = _a.variant, variant = _b === void 0 ? 'custombox' : _b, backgroundType = _a.backgroundType, color = _a.color, gradient = _a.gradient, pattern = _a.pattern, imageDisplayMode = _a.imageDisplayMode, imageTint = _a.imageTint, imageDeviation = _a.imageDeviation, width = _a.width, height = _a.height, style = _a.style;
    var showBlocked = useDeviationMatureFilter(imageDeviation).showBlocked;
    var backgroundClassNames = [];
    var sizeStyles = styleFromWidthHeight({
        width: width,
        height: height,
    });
    var styles = {};
    switch (backgroundType) {
        case BackgroundType.SOLID:
            // if the user has chosen a background color, use that.
            // If not, default to theme-based colors instead
            if (color) {
                styles.backgroundImage = "linear-gradient(".concat(color, ", ").concat(color, ")");
            }
            else {
                // we'll use a global css class that can be picked up by
                // shared's DaEditorWrapper custombox.scss
                backgroundClassNames.push(s['theme-based'], 'custombox_using_theme_defaults');
            }
            break;
        case BackgroundType.GRADIENT:
            backgroundClassNames.push(s['gradient'], gradientToClassName(gradient));
            break;
        case BackgroundType.PATTERN:
            backgroundClassNames.push(s['pattern']);
            styles.backgroundImage = "url(".concat(pattern, ")");
            break;
        case BackgroundType.IMAGE:
            backgroundClassNames.push(s['image']);
            var file = width && height
                ? MediaService.getSmallestThumbThatFullyCovers(imageDeviation, width, height, fallbackToLargestFile)
                : MediaService.getLargestFullview(imageDeviation);
            if (file) {
                styles.backgroundImage = "url(\"".concat(file.src, "\")");
            }
            if (imageTint) {
                styles.backgroundImage = "linear-gradient(".concat(imageTint, ", ").concat(imageTint, "), ").concat(styles.backgroundImage);
            }
            if (showBlocked) {
                backgroundClassNames.push(s['mature-blur']);
            }
            switch (imageDisplayMode) {
                case BackgroundImageDisplayMode.CONTAIN:
                    backgroundClassNames.push(s['display-mode-contain']);
                    break;
                case BackgroundImageDisplayMode.TILE:
                    backgroundClassNames.push(s['display-mode-repeat']);
                    break;
                case BackgroundImageDisplayMode.COVER: // pass to default
                default:
                    backgroundClassNames.push(s['display-mode-cover']);
            }
            break;
        default:
            var template = TEMPLATES.find(function (t) { return t.moduleData.backgroundType === backgroundType; });
            if (!template) {
                break;
            }
            var CACHE_BUSTER = 1;
            backgroundClassNames.push(s['image']);
            if (template.backgroundImage) {
                styles.backgroundImage = "url(\"".concat(template.backgroundImage, "?").concat(CACHE_BUSTER, "\")");
            }
            if (imageTint) {
                styles.backgroundImage = "linear-gradient(".concat(imageTint, ", ").concat(imageTint, "), ").concat(styles.backgroundImage);
            }
            switch (imageDisplayMode) {
                case BackgroundImageDisplayMode.CONTAIN:
                    backgroundClassNames.push(s['display-mode-contain']);
                    break;
                case BackgroundImageDisplayMode.TILE:
                    backgroundClassNames.push(s['display-mode-repeat']);
                    break;
                case BackgroundImageDisplayMode.COVER: // pass to default
                default:
                    backgroundClassNames.push(s['display-mode-cover']);
            }
            break;
    }
    return (React.createElement("div", { className: classnames.apply(void 0, __spreadArray(__spreadArray([s['root'],
            s["variant-".concat(variant)]], backgroundClassNames, false), [className], false)), onClick: onClick, style: __assign(__assign({}, sizeStyles), style) },
        React.createElement("div", { className: classnames(s['background'], backgroundClassName), style: styles }),
        React.createElement("div", { className: classnames(s['content'], contentClassName) }, children)));
};
Background.displayName = 'Background';
export default Background;
//# sourceMappingURL=Background.js.map